"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VU = void 0;
var AnalyticsConstants_1 = require("./AnalyticsConstants");
var EventQueue_1 = require("./eventqueue/EventQueue");
var EventQueueHandler_1 = require("./eventqueue/EventQueueHandler");
var SegmentLogger_1 = require("./loggers/SegmentLogger");
var NoTransport_1 = require("./transports/NoTransport");
var VU = /** @class */ (function () {
    function VU() {
    }
    VU.logVUEvent = function (finalPayload) {
        if (VU.isSynchronised) {
            VU.eventQueue.add(finalPayload);
            VU.eventQueuehandler.startDequeueing();
        }
        else
            VU.logger.log(finalPayload);
    };
    VU.setGlobals = function (payload) {
        VU.globals = payload;
    };
    VU.synchronised = function (value) {
        VU.isSynchronised = value;
    };
    VU.getInstance = function () {
        return VU.logger;
    };
    VU.disabled = function () {
        this.logger.isDisabled = true;
        this.logger.setTransport(new NoTransport_1.NoTransport());
    };
    VU.appEntryEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.APP_ENTRY_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.appError = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.APP_ERROR);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.appExitEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.APP_EXIT_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.contentView = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.CONTENT_VIEW);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.deepLinkError = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.DEEP_LINK_ERROR);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.deviceSettings = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.DEVICE_SETTINGS);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.errorEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.ERROR_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.identify = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.IDENTIFY);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.IDENTIFY);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.itemSelectedEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.ITEM_SELECTED_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.keyEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.KEY_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.log = function (data) {
        if (!data.getProperties()[AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE])
            data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.loginEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.LOGIN_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.loginFailureEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.LOGIN_FAILURE_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.logoutEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.LOGOUT_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.menuItemSelectedEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.MENU_ITEM_SELECTED_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.milestoneReachedEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.MILESTONE_REACHED_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.notifyEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.NOTIFY_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.screen = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.SCREEN);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.streamingRecovery = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.STREAMING_RECOVERY);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.tivoAppStart = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.TIVO_APP_START);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.trickPlayEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.TRICK_PLAY_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.userActionEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.USER_ACTION_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.userAgreement = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.USER_AGREEMENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.watchStartedEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.WATCH_STARTED_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.watchStoppedEvent = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, AnalyticsConstants_1.AnalyticsConstants.Events.WATCH_STOPPED_EVENT);
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE, AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK);
        var finalPayload = data.merge(VU.globals);
        VU.logVUEvent(finalPayload);
    };
    VU.setEventQueueSize = function (size) {
        VU.eventQueue.setSize(size);
    };
    VU.noConsole = function () {
        this.logger.noConsole = true;
    };
    VU.logger = new SegmentLogger_1.SegmentLogger();
    VU.eventQueue = new EventQueue_1.EventQueue();
    VU.isSynchronised = true;
    VU.eventQueuehandler = new EventQueueHandler_1.EventQueueHandler(VU.logger, VU.eventQueue);
    return VU;
}());
exports.VU = VU;
